import kylinIcon from "@/assets/download/kylin.png";
import androidIcon from "@/assets/download/android.svg";
import windowsIcon from "@/assets/download/windows.svg";
import iosIcon from "@/assets/download/ios.svg";
import macIcon from "@/assets/download/mac.svg";

const ICON_BY_ID = {
  2: androidIcon,
  3: windowsIcon,
  8: kylinIcon,
  9: macIcon,
  10: iosIcon,
};

const ICON_BY_NAME = {
  APK下载: androidIcon,
  QT下载: windowsIcon,
  "QT(麒麟V10触摸屏)": kylinIcon,
  Mac: macIcon,
  macOS: macIcon,
  iOS: iosIcon,
  IOS: iosIcon,
};

const ICON_BY_KEY = {
  android: androidIcon,
  windows: windowsIcon,
  kylin: kylinIcon,
  mac: macIcon,
  ios: iosIcon,
};

export function resolveDownloadIcon(item) {
  if (!item) {
    return "";
  }
  const id = String(item.id || item.welcomeId || "");
  const name = item.name || item.matchName || item.itemName || "";
  const key = item.key || "";
  if (ICON_BY_KEY[key]) {
    return ICON_BY_KEY[key];
  }
  if (ICON_BY_ID[id]) {
    return ICON_BY_ID[id];
  }
  if (ICON_BY_NAME[name]) {
    return ICON_BY_NAME[name];
  }
  return item.icon || "";
}

export { androidIcon, windowsIcon, kylinIcon, iosIcon, macIcon };
